export const CLASS_NAME = 'cst-download-button'
